<input #fileInputDrag type="file" [attr.accept]="accept" (change)="uploadByEvent($event)" hidden />

<div
    class="edInputFile"
    [id]="innerId"
    [ngClass]="{
        'file-loaded': !!file,
        'file-oversized': isFileOversized,
        'file-errors': isAnyErrorDefined,
    }"
    onkeypress="">
    @if (!file) {
        <div class="init" (click)="fileInputDrag.click()" (appDropZone)="upload($event)">
            <div class="circle-gray">
                <i class="icon-upload-cloud-02"></i>
            </div>

            <div class="message">
                <span>Cliquez pour téléverser le fichier</span> ou glissez - déposez
            </div>
            <!-- <div *ngIf="allowedFormat">
                    {{ allowedFormat.join(', ') }}
                </div> -->
        </div>
    }

    @if (!!file && !isFileOversized && !isAnyErrorDefined) {
        <div class="file-preview">
            <div class="valid-file">
                <i class="bi bi-check2-circle"></i>
                <div class="description">
                    Le fichier {{ fileTypeLabel }} a correctement été déposé !
                </div>
            </div>

            <div class="file-info">
                <div class="file-specs">
                    <i class="icon-file-download-02"></i>
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-size">{{ fileSize }} {{ fileSizeUnitLabel }}</div>
                </div>

                <ed-button
                    [colorSchema]="buttonColors.Secondary"
                    [icon]="'icon-trash-01'"
                    title="Supprimer le fichier"
                    (click)="$event.stopPropagation(); removeFile()">
                </ed-button>
            </div>
        </div>
    }

    @if (!!file && isFileOversized) {
        <div class="error-oversized-file">
            <div class="file-info">
                <div class="file-specs">
                    <i class="icon-file-x-02"></i>
                    <div class="file-name">{{ file!.name }}</div>
                    <div class="file-size">{{ fileSize }} {{ fileSizeUnitLabel }}</div>
                </div>

                <ed-button
                    [colorSchema]="buttonColors.Secondary"
                    [icon]="'icon-trash-01'"
                    title="Supprimer le fichier"
                    (click)="$event.stopPropagation(); removeFile()">
                </ed-button>
            </div>

            <div class="message">
                Erreur de chargement : La taille du fichier ne doit pas dépasser
                {{ maxFileSizeInMo }} Mo.
            </div>
        </div>
    }

    @if (!!file && !isFileOversized && isAnyErrorDefined) {
        <div class="value-error">
            <div class="message">
                <i class="icon-alert-triangle"></i>
                <div>Le fichier a correctement été déposé mais contient des erreurs !</div>
            </div>

            <div class="file-info">
                <div class="file-specs">
                    <i class="icon-file-x-02"></i>
                    <div class="file-name">{{ file!.name }}</div>
                    <div class="file-size">{{ fileSize }} {{ fileSizeUnitLabel }}</div>
                </div>

                <ed-button
                    [colorSchema]="buttonColors.Secondary"
                    [icon]="'icon-trash-01'"
                    title="Supprimer le fichier"
                    (click)="$event.stopPropagation(); removeFile()">
                </ed-button>
            </div>

            <div class="errors">
                <h6 class="title">
                    <i class="icon-info-circle"></i>
                    <span>Rapport d'erreurs</span>
                </h6>

                <ng-container
                    *ngIf="errorTemplate; else defaultErrorMessage"
                    [ngTemplateOutlet]="errorTemplate">
                </ng-container>

                <ng-template #defaultErrorMessage>
                    <div>Aucune erreur détaillée disponible.</div>
                </ng-template>

                <div class="reload" (click)="reloadFile(); $event.stopPropagation()">
                    Recharger un fichier
                </div>
            </div>
        </div>
    }
</div>
